import React, { Fragment, ReactNode } from 'react';
import { GoalAccomplishmentExtendedDto } from 'src/api/v2';
import GoalCard from '../reporting/components/GoalAchievement/GoalCard';
import { Grid, GridItem, Heading } from '@innovationnorway/cl-react';

export const createGoalList = (goals: GoalAccomplishmentExtendedDto[], link: boolean = false) => {
  const sortedGoals = goals.sort((a, b) => {
    if (!a.goalCategory.name || !b.goalCategory.name) return 0;
    return a.goalCategory.name.localeCompare(b.goalCategory.name);
  });

  type Category = {
    header: ReactNode;
    elements: ReactNode[];
  };

  const nodeArray: Category[] = [];
  let groupIndex = 0;
  sortedGoals.forEach((goal, index, array) => {
    if (index === 0) {
      nodeArray.push({
        header: <Heading level={3}>{goal.goalCategory.name}</Heading>,
        elements: [],
      });
    } else if (array[index - 1].goalCategory.name !== goal.goalCategory.name) {
      nodeArray.push({
        header: <Heading level={3}>{goal.goalCategory.name}</Heading>,
        elements: [],
      });
      groupIndex++;
    }
    nodeArray[groupIndex].elements.push(
      <GridItem key={goal.id} spanLarge={6} spanMedium={6} spanSmall={4}>
        <GoalCard link={link} goal={goal} />
      </GridItem>,
    );
  });

  return (
    <>
      {nodeArray.map((category, index) => {
        return (
          <Fragment key={`category__${index}`}>
            {category.header}
            <Grid gap="m">{category.elements}</Grid>
          </Fragment>
        );
      })}
    </>
  );
};
